export default [
  {
    path: '',
    name: 'move order list',
    component: () => import('@/views/app/move-order/list/page-list.vue'),
    meta: { title: 'Daftar Mutasi Barang' },
  },
  {
    path: 'product-pending',
    name: 'move order product pending',
    component: () => import('@/views/app/move-order/product-pending/page-list.vue'),
    meta: { title: 'Produk Pending Mutasi' },
  },
  {
    path: ':id',
    name: 'move order detail',
    component: () => import('@/views/app/move-order/detail/page-detail.vue'),
    meta: { title: 'Detail Mutasi Barang' },
  },
]

